// extracted by mini-css-extract-plugin
export default {"main":"notifications_main__EWzyQ"};